define('helperLayout',['require','helperLayout-createNode','helperLayout-appendContent','helperLayout-prependContent','helperLayout-nodeStyle','helperLayout-isMissing','helperLayout-scrollTop','helperLayout-setImagesSource','helperLayout-setSvgTexts','helperLayout-fixSvgTexts'],function(require) {
    'use strict';

    var layout = {
        createNode: require('helperLayout-createNode'),
        appendContent: require('helperLayout-appendContent'),
        prependContent: require('helperLayout-prependContent'),
        nodeStyle: require('helperLayout-nodeStyle'),
        isMissing: require('helperLayout-isMissing'),
        scrollTop: require('helperLayout-scrollTop'),
        setImagesSource: require('helperLayout-setImagesSource'),
        setSvgTexts: require('helperLayout-setSvgTexts'),
        fixSvgTexts: require('helperLayout-fixSvgTexts')
    };

    return layout;

});

